import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const steps = [{
  id: 1,
  title: "Send the spec, drawing & sample part",
  description: "The governing standard, material, content, marking location, and quantity; or a marked-up drawing. Evermark recommends a method if unspecified."
}, {
  id: 2,
  title: "Get a quote",
  description: "Material/method, content, verification level, quantity pricing, lead time, and program terms."
}, {
  id: 3,
  title: "Approve a first article",
  description: "Evermark produces a first article; material, placement, content, and (when required) grade are confirmed against the spec before the run."
}, {
  id: 4,
  title: "Production marking",
  description: "Produced by the approved method with in-process checks; verification and grading when specified."
}, {
  id: 5,
  title: "Deliver & document",
  description: "Marking delivered with the documentation the program requires — traceability and verification records when specified. {{verify: available quality documentation}}."
}];
export default function HowToStart() {
  return <section id="how-to-start" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">
            How Do You Start a Marine or Aerospace Marking Program?
          </h2>
          <p className="font-sans text-lg text-muted-foreground">
            Starting a marine or aerospace marking program with Evermark Industrial Solutions follows a five-step path built around the specification and a first article.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {steps.map((step, i) => <Card key={step.id} data-index={i} className="bg-card border-border shadow-sm flex flex-col h-full">
              <CardHeader className="pb-4">
                <div className="font-default text-5xl md:text-6xl font-bold text-primary mb-4 opacity-90">
                  0{step.id}
                </div>
                <CardTitle className="font-default text-xl text-card-foreground leading-tight">
                  {step.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <p className="font-sans text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-12 md:mt-16 flex justify-center">
          <Button asChild size="lg" className="px-8 py-6 text-base">
            <Link to="/ContactPage">Request a Quote</Link>
          </Button>
        </div>
      </div>
    </section>;
}